import { render, staticRenderFns } from "./AddOrderView.vue?vue&type=template&id=ac7f2e12"
import script from "./AddOrderView.vue?vue&type=script&lang=js"
export * from "./AddOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports